export default {
  store_on_process:
    "Loja em processo de criação, dentro de instantes seu link estará disponivél",
};
